﻿'use strict';

angular.module('ntmApp').factory('TimeFilter', function () {

    function TimeFilter(labelPattern) {
        var pattern = labelPattern;
        this.hours = null;
        this.minutes = null;
        this.comparator = ">=";

        this.isDefined = function () {
            return (this.hours || this.hours === 0) &&
                   this.comparator &&
                   (this.minutes || this.minutes === 0);
        };

        this.isPartlyDefined = function () {
            return (this.hours || this.hours === 0) ||
                (this.minutes || this.minutes === 0) ||
                this.comparator !== ">=";
        };

        this.clear = function () {
            this.hours = null;
            this.comparator = ">=";
            this.minutes = null;
        };

        this.getLabel = function () {
            return pattern.format(this.comparator, this.hours, this.minutes);
        };
    }

    return (TimeFilter);
});